import React from "react";
import { Button, Input, Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { Controller } from "react-hook-form";
import { FavoritesEnum } from "@scenes/favorites/utils/FavoritesUtils";
import { useTheme } from "styled-components/native";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";

interface FavoritesModalProps {
  control: any;
  setValue: any;
  handleSubmit: any;
  onSubmit: any;
  isCollectionEventLoading: boolean;
  setIsCreateNewCollectionModalOpen: any;
  isCreateNewCollectionModalOpen: boolean;
  checkEnableCollectionButton: any;
  setCollectionEventLoading: any;
  enableCollectionButton: boolean;
}

const FavoritesModel: React.FC<FavoritesModalProps> = ({
  control,
  setValue,
  handleSubmit,
  onSubmit,
  isCollectionEventLoading,
  setIsCreateNewCollectionModalOpen,
  isCreateNewCollectionModalOpen,
  checkEnableCollectionButton,
  setCollectionEventLoading,
  enableCollectionButton,
}) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();

  return (
    <Modal
      headerTitle={t("favorites.createNewCollection.text")}
      isOpen={isCreateNewCollectionModalOpen}
      onClose={() => {
        setIsCreateNewCollectionModalOpen(false);
        setValue(FavoritesEnum.collection_name, "");
        checkEnableCollectionButton("");
      }}
      paddingLeft={16}
      paddingRight={16}
      paddingBottom={40}
      paddingTop={16}
    >
      <Controller
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <Input
            inputLabel={t("favorites.collectionName.text")}
            placeholder={t("favorites.collectionName.text")}
            hideIconContainer={true}
            onBlur={onBlur}
            onChangeText={(text) => {
              onChange(text.trimStart());
              checkEnableCollectionButton(text.trimStart());
            }}
            value={value}
          />
        )}
        name={FavoritesEnum.collection_name}
      />
      <Spacer size={SpaceType.Big} />
      <VDBText color={theme["core-05"]} type={typography["Body-R"]}>
        {t("favorites.addItemsToDefaultCollection.text")}
      </VDBText>

      <Spacer size={SpaceType.Big} />

      <Button
        loading={isCollectionEventLoading}
        type={ButtonType.primary}
        disabled={!enableCollectionButton}
        category={ButtonCategory.default}
        title={t("favorites.createNewCollection.text")}
        onPress={() => {
          setCollectionEventLoading(true);
          handleSubmit(onSubmit)();
        }}
      />
    </Modal>
  );
};

export default FavoritesModel;
